import React from 'react';
import {
    ModalContainer,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalFormLabel,
    ModalForm,
    ModalTextArea,
    ModalCloseButton,
    ModalButton,
    ReturnModalOverlay
} from './ReturnModalElements';

const ReturnModal = ({ isOpen, onClose, handleReturnProcess }) => {

    if (!isOpen) return null;

    return (
        <ReturnModalOverlay>
            <ModalContainer>
                <ModalHeader>Clicking 'Proceed' below will initiate the return process and, where applicable, cancel your subscription. Would you like to proceed?</ModalHeader>
                <ModalFooter>
                    <ModalCloseButton onClick={onClose}>Cancel</ModalCloseButton>
                    <ModalButton onClick={(e) => handleReturnProcess(e)}>Proceed</ModalButton>
                </ModalFooter>
            </ModalContainer>
        </ReturnModalOverlay>
    );
};


export default ReturnModal;
